import { resolve } from 'path';
import store from '../store/index.js'
import Vue from '@/main'
const processEnv = process.env;
let permissionInfo = store.state.admin.permissionInfo

const config = {
  originalForward: {
    url: "/originalForward.do"
  },
  gwforward: {    
    url: "/gwforward"
  },
  findMemu: {
    //获取菜单
    url: "/findMemu",
    method: "GET",
    baseUrl: processEnv.ISPRIVATE
      ? processEnv.ORIGINAL_ROOT + processEnv.MENU_URL
      : processEnv.MENU_URL
  },

  getTenantInfoByTenantId: {
    // 获取租户信息
    url: processEnv.GATEWAY?"/local/getTenantById":"/getTenantById",
    method: "GET",
    baseUrl: processEnv.ISPRIVATE ? processEnv.ORIGINAL_ROOT + "/tenant" : "" 
  },

  saveColumn: {
    //添加栏目
    url: "/cmscolumn/appcolumn/saveColumn",
    method: "POSTJSON",
    //authPermission: 'column_add'
  },
  updateColumn: {
    //修改栏目
    url: "/cmscolumn/appcolumn/updateColumn",
    method: "POSTJSON",
    //authPermission: 2
  },
  batchUpdateDisplay: {
    //
    url: "/cmscolumn/column/batchUpdateDisplay",
    method: "POSTJSON",
    //authPermission: "2"
  },
  copyColumn: {
    url: "/cmscolumn/appcolumn/copyColumn",
    method: "POSTJSON",
    //authPermission: "1"
  },
  validColumnByColumnIds: {
    //验证栏目是否还有内容
    url: "/cmscolumn/appcolumn/validateIdDel",
    method: "GET",
  },
  deleteColumnByColumnIds: {
    //根据批量栏目ID删除栏目
    url: "/cmscolumn/appcolumn/deleteColumnByColumnIds",
    method: "POSTJSON",
  },
  dragAndDropSort: {
    //拖拽转移/排序
    url: "/cmscolumn/column/dragAndDropSort",
    method: "GET",
    //authPermission: "25"
  },
  batchMoveColumn: {
    //批量转移栏目到目标栏目最底部
    url: "/cmscolumn/column/batchMoveColumn",
    method: "POSTJSON",
    //authPermission: "21"
  },
  getColumnTree: {
    //获取栏目tree
    url: "/cmscolumn/appcolumn/getColumnTree",
    method: "GET"
  },
  getSiteColumnTree: {
    //获取种子站栏目tree
    url: "/cmscolumn/appcolumn/getSiteColumnTree",
    method: "GET"
  },
  getColumnById: {
    //根据栏目ID获取栏目
    url: "/cmscolumn/appcolumn/getColumnById",
    method: "GET"
  },
  findColumnByConditionWithPage: {
    //根据条件分页获取栏目
    url: "/cmscolumn/column/findColumnByConditionWithPage",
    method: "POSTJSON"
  },
  findColumnByCondition: {
    url: "/cmscolumn/column/findColumnByCondition",
    method: "POSTJSON"
  },
  getCountries: {
    url:'/region/countryService/getCountries',
    method:'GET',
  },
  getRegionsTree: {
    url:'/region/regionService/getRegionsTree',
    method:'GET',
  },
  saveGroup: {
    //添加栏目组
    url: "/cmscolumn/column/saveGroup",
    method: "POSTJSON",
    //authPermission: "9"
  },
  updateGroup: {
    //修改栏目组
    url: "/cmscolumn/column/updateGroup",
    method: "POSTJSON",
    //authPermission: "10"
  },
  deleteGroup: {
    //删除栏目组
    url: "/cmscolumn/column/deleteGroup",
    method: "POSTJSON",
    //authPermission: "11"
  },
  getGroupById: {
    //根据栏目组ID获取栏目组
    url: "/cmscolumn/column/getGroupById",
    method: "GET"
  },
  findColumnByGroupId: {
    url: "/cmscolumn/column/findColumnByGroupId",
    method: "GET"
  },
  getColumnGroup: {
    //获取栏目组列表
    url: "/cmscolumn/column/findAllGroup",
    method: "GET"
  },
  ResetColumnGroupPK: {
    url: "/cmscolumn/column/ResetColumnGroupPK",
    method: "POSTJSON",
    //authPermission: "2"
  },
  saveColumnGroupPK: {
    //批量保存栏目与栏目组关系
    url: "/cmscolumn/column/saveColumnGroupPK",
    method: "POSTJSON",
    //authPermission: "10"
  },
  deletePKByColumnIdOrGroupId: {
    //根据批量栏目ID或批量栏目组Id删除关系
    url: "/cmscolumn/column/deletePKByColumnIdOrGroupId",
    method: "POSTJSON",
    //authPermission: "10"
  },

  // 获取字段类型
  getFiledType: {
    url: "/cmscolumn/field/getFieldType",
    method: "GET"
  },

  saveField: {
    //添加栏目内容字段
    url: "/cmscolumn/field/saveField",
    method: "POSTJSON",
    //authPermission: "15"
  },
  saveFieldByTempId: {
    //根据字段模板Id添加栏目内容字段
    url: "/cmscolumn/field/saveFieldByTempId",
    method: "POSTJSONGET",
    //authPermission: "15"
  },
  updateField: {
    //根据字段模板Id添加栏目内容字段
    url: "/cmscolumn/field/updateField",
    method: "POSTJSON",
    //authPermission: "16"
  },
  batchUpdateField: {
    //根据字段模板Id添加栏目内容字段批量修改
    url: "/cmscolumn/field/batchUpdateField",
    method: "POSTJSON",
  },
  updateFieldBase: {
    //根据字段模板Id添加栏目内容字段
    url: "/cmscolumn/field/updateFieldBase",
    method: "POSTJSON",
    // authPermission: "16"
  },  
  batchUpdateFieldDisplay: {
    //根据字段模板Id批量显示隐藏d
    url: "/cmscolumn/field/batchUpdateDisplay",
    method: "POSTJSON",
  },
  deleteField: {
    //根据批量栏目内容字段ID删除字段
    url: "/cmscolumn/field/deleteField",
    method: "POSTJSON",
    //authPermission: "17"
  },
  getFieldById: {
    //根据栏目内容字段ID获取栏目内容字段对象
    url: "/cmscolumn/field/getFieldById",
    method: "GET"
  },
  findFieldByConditionWithPage: {
    //根据条件分页查询栏目内容字段
    url: "/cmscolumn/field/findFieldByConditionWithPage",
    method: "POSTJSON"
  },
  validateFieldName: {
    //校验字段名
    url: "/cmscolumn/field/validateFieldName",
    method: "GET"
  },

  //根据类型校验字段名
  validateFieldNameByType: {
    url: "/cmscolumn/field/validateFieldNameWithType",
    method: "GET"
  },

  findFieldsByColumnIds: {
    url: "/cmscolumn/field/findFieldsByColumnIds",
    method: "GET"
  },
  findFieldByCondition: {
    //根据条件查询栏目内容字段
    url: "/cmscolumn/field/findFieldByCondition",
    method: "POSTJSON"
  },
  findFieldsByColumnIdOrTempId: {
    //根据种子站栏目ID获取字段组
    url: "/cmscolumn/field/findFieldsByColumnIdOrTempId",
    method: "GET"
  },
  findFieldWithRangeByCondition: {
    //根据条件查询栏目内容字段包含区间字段
    url: "/cmscolumn/field/findFieldWithRangeByCondition",
    method: "POSTJSON"
  },
  dragAndDropSortField: {
    url: "/cmscolumn/field/dragAndDropSort",
    method: "GET",
    //authPermission: "16"
  },

  // saveItems: {//批量添加栏目内容选项型字段条目
  //   url: '/cmscolumn/field/saveItems',
  //   method: 'POSTJSON'
  // },
  // updateItem: {//修改字段ID删除条目
  //   url: '/cmscolumn/field/updateItem',
  //   method: 'POSTJSON'
  // },
  // deleteByFieldIds: {//根据批量字段ID删除条目
  //   url: '/cmscolumn/field/deleteByFieldIds',
  //   method: 'POSTJSON'
  // },
  // findItemsByFieldId: {//根据字段ID获取条目
  //   url: '/cmscolumn/field/findItemsByFieldId',
  //   method: 'GET'
  // },
  // saveValidate: {//保存栏目内容字段校验对象
  //   url: '/cmscolumn/field/saveValidate',
  //   method: 'POSTJSON'
  // },
  // updateValidate: {//修改栏目内容字段校验对象
  //   url: '/cmscolumn/field/updateValidate',
  //   method: 'POSTJSON'
  // },
  saveOrUpdateValidate: {
    //保存或更新字段的表单验证
    url: "/cmscolumn/field/saveOrUpdateValidate",
    method: "POSTJSON",
    //authPermission: "16"
  },
  // deleteValidateByFieldIds: {//根据批量字段ID删除栏目内容字段校验对象
  //   url: '/cmscolumn/field/deleteValidateByFieldIds',
  //   method: 'POSTJSON'
  // },
  getValidateByFieldId: {
    //根据字段ID获取栏目内容字段校验对象
    url: "/cmscolumn/field/getValidateByFieldId",
    method: "GET"
  },
  findGroupByColumnId: {
    //根据栏目ID获取字段组
    url: "/cmscolumn/field/findGroupByColumnId",
    method: "GET"
  },
  getFieldGroupById: {
    //根据ID获取字段组
    url: "/cmscolumn/field/getGroupById",
    method: "GET"
  },
  saveFieldGroup: {
    //保存字段组
    url: "/cmscolumn/field/saveGroup",
    method: "POSTJSON",
    //authPermission: "18"
  },
  updateFieldGroup: {
    //更新字段组
    url: "/cmscolumn/field/updateGroup",
    method: "POSTJSON",
    //authPermission: "19"
  },
  deleteFieldGroup: {
    //删除字段组
    url: "/cmscolumn/field/deleteGroup",
    method: "POSTJSON",
    //authPermission: "20"
  },

  /*-------------------------------------------- 内容 ----------------------------------------------------*/

  insertContent: {
    //添加内容
    url: "/cmscontent/appContentService/insert",
    method: "POSTJSON",
    //authPermission: "columnId:27"
  },
  updateContent: {
    // 更新内容
    url: "/cmscontent/appContentService/update",
    method: "POSTJSON",
    //authPermission: "columnId:28"
  },
  copyInsert: {
    //复制
    url: "/cmscontent/contentManualService/copyInsert",
    method: "GET",
    //authPermission: "columnId:27"
  },
  selectContent: {
    // 查询单条 内容对象
    url: "/cmscontent/appContentService/select",
    method: "GET"
  },
  findByPagination: {
    // 分页查询  (内容列表)
    url: "/cmscontent/appContentService/findByPagination",
    method: "POSTJSON"
  },
  findContentByPagination: {
    // 分页查询  (内容列表新)
    url: "/cmscontent/appContentService/findContentByPagination",
    method: "POSTJSON"
  },
    // 导出内容模板
    exportContentTemplate: {
      url: "/cmscontent/appContentService/getTemplate",
      method: "GET"
    },

    // 导入内容模板
    importContentTemplate: {
      url: "/cmscontent/appContentService/importContent",
      method: "FILESTREAM"
    },


  updateShow: {
    // 更新内容隐藏可见
    url: "/cmscontent/contentManualService/updateShow",
    method: "POSTJSON",
    //authPermission: "columnId:28"
  },
  top: {
    // 置顶
    url: "/cmscontent/contentManualService/top",
    method: "POSTJSON",
    //authPermission: "columnId:28"
  },

  recommend: {
    // 推荐/取消推荐内容
    url: "/cmscontent/contentManualService/recommend",
    method: "POSTJSON",
    //authPermission: "columnId:28"
  },
  ResetContentGroupPK: {
    // 绑定内容内容组关系
    url: "/cmscontent/contentManualService/restContentGroup",
    method: "POSTJSON",
    //authPermission: "columnId:28"
  },

  hot: {
    // 热点/取消热点内容
    url: "/cmscontent/contentManualService/hot",
    method: "POSTJSON",
    //authPermission: "columnId:28"
  },
  newest: {
    // 最新/取消最新内容
    url: "/cmscontent/contentManualService/newest",
    method: "POSTJSON",
  },
  sort: {
    // 排序
    url: "/cmscontent/contentManualService/sort",
    method: "GET",
    //authPermission: "columnId:28"
  },
  findFieldsByColumnId: {
    url: "/cmscolumn/field/findFieldsByColumnId",
    method: "GET"
  },
  updateDel: {
    // 删除
    url: "/cmscontent/contentManualService/updateDel",
    method: "POSTJSON",
    //authPermission: "columnId:29"
  },
  rebackContent: {
    // 还原
    url: "/cmscontent/contentManualService/updateDel",
    method: "POSTJSON",
    //authPermission: "6"
  },
  contentTransfer: {
    //内容转移
    url: "/cmscontent/contentManualService/transfer?",
    method: "POSTJSON",
    //authPermission: "trasColumnId:31"
  },
  getSendState: {
    // 判断栏目有没有手动转发
    url: "/cmscontent/appContentForwardService/getSendState",
    method: "POSTJSON"
  },
  manualForward: {
    // 手动跨站转发
    url: "/cmscontent/appContentForwardService/manualForward",
    method: "POSTJSON",
    //authPermission: "columnId:31"
  },
  //--------------------------------图片插件-------------------------------------------------
  findByPaginationForImage: {
    //分页查找
    url: "/imageRepository/imageRepositoryService/findByPagination",
    method: "POSTJSON"
  },
  deleteImageInfo: {
    //删除图片
    url: "/imageRepository/imageRepositoryService/deleteImageInfo",
    method: "POSTJSON",
    //authPermission: "46"
  },
  updateImage: {
    //更新单个updateImageInfo
    url: "/imageRepository/imageRepositoryService/updateImage",
    method: "FILE",
    //authPermission: "44"
  },
  updateImageInfo: {
    url: "/imageRepository/imageRepositoryService/updateImageInfo",
    method: "POSTJSON",
    //authPermission: "44"
  },
  uploadImage: {
    //添加图片
    url: "/imageRepository/imageFileUpload",
    method: "UPLOADFILE",
    //authPermission: "43",
    baseUrl:processEnv.DSSRESOURCES,
    isGwforward:true//true走gwforward转发
  },
  getImageInfo: {
    //获取图片getImageInfo
    url: "/imageRepository/imageRepositoryService/getImageInfo",
    method: "GET"
  },
  setWaterMark: {
    //批量添加水印setWaterMark
    url: "/imageRepository/imageRepositoryService/setWaterMark",
    method: "POSTJSON",
    //authPermission: "47"
  },
  cancelWatermark: {
    //批量删除水印cancelWatermark
    url: "/imageRepository/imageRepositoryService/cancelWatermark",
    method: "POSTJSON",
    //authPermission: "47"
  },
  getImageWatermark: {
    //获取水印设置getImageWatermark
    url: "/imageRepository/imageWatermarkService/getImageWatermark",
    method: "GET"
  },
  saveOrUpdateWaterMark: {
    //保存或修改水印saveOrUpdateWaterMark
    url: "/imageRepository/imageWatermarkService/saveOrUpdateWaterMark",
    method: "POSTJSON",
    //authPermission: "47"
  },
  updateAppCode: {
    //转移分类updateAppCode
    url: "/imageRepository/imageRepositoryService/updateAppCode",
    method: "POSTJSON",
    //authPermission: "45"
  },
  findAllClassify: {
    //获取APP_ID下所有分类findAllClassify
    url: "/classify/findAllClassify",
    method: "POSTJSON"
  },
  findAllClassifyByImage: {
    //获取APP_ID下所有分类文件findAllClassify及数量
    url: "/imageRepository/appImageRepositoryService/findAllClassify",
    method: "POSTJSON"
  },
  saveClassify: {
    //保存分类信息 saveClassify
    url: "/classify/saveClassify",
    method: "POSTJSON",
    //authPermission: "86"
  },
  updateClassify: {
    //更新分类信息 updateClassify
    url: "/classify/updateClassify",
    method: "POSTJSON",
    //authPermission: "87"
  },
  deleteClassifyByIds: {
    //删除分类信息 deleteClassifyByIds
    url: "/classify/deleteClassifyByIds",
    method: "POSTJSON",
    //authPermission: "88"
  },
  getClassifyById: {
    //根据id获取分类信息 getClassifyById
    url: "/classify/getClassifyById",
    method: "GET"
  },
  getClassifyByName: {
    //根据name获取分类信息 getClassifyByName
    url: "/classify/getClassifyByName",
    method: "GET"
  },
  preWaterMark: {
    //水印预览
    url: "/imageRepository/imageWatermarkService/preWaterMark",
    method: "POSTJSON"
  },
  getImageUsage: {
    //获取图片资源
    url: "/imageRepository/imageRepositoryService/getImageUsage",
    method: "GET"
  },

  //--------------------------------文件库插件-------------------------------------------------
  uploadFile: {
    //根据条件分页查询文件库信息findByPagination
    url: "/upload/uploadService/uploadFile",
    //authPermission: "48"
  },
  updateFile: {
    //根据条件分页查询文件库信息findByPagination
    url: "/upload/uploadService/updateFile",
    //authPermission: "49"
  },
  findByPaginationForFile: {
    //根据条件分页查询文件库信息findByPagination
    url: "/file/info/findWithPage",
    method: "POSTJSON"
  },
  deleteFileByIds: {
    //根据批量文件库信息id删除未引用文件delete
    url: "/file/appinfo/deleteFileByIds",
    method: "POSTJSON",
    //authPermission: "51"
  },
  saveFile: {
    //保存文件库信息saveFileInfomation
    url: "/file/info/saveFile",
    method: "POSTJSON",
    //authPermission: "48"
  },
  getFileById: {
    //根据文件ID查询文件信息get
    url: "/file/info/getFileById",
    method: "GET"
  },
  modifyFileName: {
    //修改文件名get
    url: "/file/info/updateFile",
    method: "POSTJSON",
    //authPermission: "49"
  },
  transferFile: {
    //文件转移
    url: "/file/info/moveFields",
    method: "POSTJSON",
    //authPermission: "50"
  },
  findAllClassifyByFile: {
    url: "/file/appinfo/findAllClassify",
    method: "POSTJSON"
  },
  //--------------------------------广告插件-------------------------------------------------
  findByPaginationForBanner: {
    //分页查询广告位findByPagination
    url: "/advert/advertPositionService/findByPagination",
    method: "POSTJSON"
  },
  findBannerById: {
    //根据id获得banner基本信息
    url: "/advert/advertPositionService/getBase",
    method: "GET"
  },
  addBanner: {
    //添加广告位add
    url: "/advert/advertPositionService/add",
    method: "POSTJSON",
    //authPermission: "32"
  },
  updateBanner: {
    //修改广告位update
    url: "/advert/advertPositionService/update",
    method: "POSTJSON",
    //authPermission: "33"
  },
  deletePositionBanner: {
    //根据广告位ID删除一个广告位deletePosition
    url: "/advert/appAdvertService/deletePosition",
    method: "POSTJSON",
    //authPermission: "36"
  },
  findByPaginationImageForBanner: {
    //分页查询findByPagination
    url: "/advert/advertContentService/findByPagination",
    method: "POSTJSON"
  },
  getImageForBanner: {
    //分页查询findByPagination
    url: "/advert/advertContentService/get",
    method: "GET"
  },
  batchAddAdvertContentForBanner: {
    //指添加广告内容batchAddAdvertContent
    url: "/advert/appAdvertService/batchAddAdvertContent",
    method: "POSTJSON",
    //authPermission: "32"
  },
  updateAdvertContentForBanner: {
    //更新广告内容updateAdvertContent
    url: "/advert/appAdvertService/updateAdvertContent",
    method: "POSTJSON",
    //authPermission: "33"
  },
  deleteAdvertContent: {
    //删除广告内容deleteAdvertContent
    url: "/advert/appAdvertService/deleteAdvertContent",
    method: "POSTJSON",
    //authPermission: "33"
  },

  getBaseConfig: {
    //获取基础设置
    url: "/config/baseConfigService/getBaseConfig",
    method: "GET"
  },
  setBaseConfig: {
    //保存基础设置
    url: "/config/baseConfigService/saveBaseConfig",
    method: "POSTJSON",
    //authPermission: "77"
  },
  getSiteMail: {
    //获取站点邮箱
    url: "/config/siteMailService/getSiteMail",
    method: "GET"
  },
  setSiteMail: {
    //设置站点邮箱
    url: "/config/siteMailService/setSiteMail",
    method: "POSTJSON",
    //authPermission: "78"
  },
  getSeoCode: {
    //获取第三方代码
    url: "/config/baseConfigService/getSeoCode",
    method: "GET"
  },
  setSeoCode: {
    //保存第三方代码
    url: "/config/baseConfigService/setSeoCode",
    method: "POSTJSON",
    //authPermission: "79"
  },

  getTenantConfigByKey: {
    // 通过键值获取租户设置
    url: "/service/tenantConfig/getByKey",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },

  addTenantConfig: {
    // 添加租户配置
    url: "/service/tenantConfig/add",
    method: "POSTJSON",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },

  updateTenantConfig: {
    // 修改租户配置
    url: "/service/tenantConfig/update",
    method: "POSTJSON",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  
  getSaleCode: {
    //获取授权码
    url: "generatorTenantKey",
    method: "GET",
    baseUrl: processEnv.APP_URL
  },

  // getSiteMail: { //获取seo代码
  //   url: '/config/baseConfigService/getSeoCode',
  //   method: 'GET'
  // },
  // setSiteMail: { //设置seo代码
  //   url: '/config/baseConfigService/getSeoCode',
  //   method: 'POSTJSON'
  // },
  /*-------------------------------------------- SEO设置 ----------------------------------------------------*/
  getSeoDefaultBy: {
    //获取默认seo数据
    url: "/service/seoDefault/findSeoDefaultList",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  getSeoDefaultByNew: {
    //获取默认seo数据与全网关键词设置同步
    url: "/service/seoDefault/getSeoDefault",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  getSeoDataSourceBy: {
    //获取seo数据源
    url: "/service/seoDefault/findSeoDataSourceList",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  getSeoSpreadBy: {
    //获取修改后的seo数据
    url: "/service/seoSpread/getSeoSpread",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  saveSeoSpread: {
    //保存seo数据
    url: "/service/seoSpread/saveSeoSpread",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  updateSeoSpread: {
    //更新seo数据
    url: "/service/seoSpread/updateSeoSpread",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  getWebSiteRule: {
    //获取网址url规则
    url: "/config/siteRuleService/getWebSiteRule",
    method: "GET"
  },
  saveRule: {
    //保存优化规则
    url: "/config/siteRuleService/saveRule",
    method: "POSTJSON",
    //authPermission: "74"
  },
  findPages: {
    //获取其他关键词设置
    url: "/site/page/findPages",
    method: "POSTJSON",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  getSeoOtherBy: {
    //获取其他页面seo数据
    url: "/service/seoOther/getSeoOtherByPageId",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  saveSeoOther: {
    //保存其他页面seo数据
    url: "/service/seoOther/saveSeoOther",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  updateSeoOther: {
    //保存其他页面seo数据
    url: "/service/seoOther/updateSeoOther",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  deleteSeoOther: {
    //删除其他页面seo数据
    url: "/service/seoOther/deleteSeoOther",
    method: "POSTJSON",
    //authPermission: "75",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },
  findSeoAppsByTenantId: {
    //获取插件关键词列表
    url: "findSeoAppsByTenantId",
    method: "GET",
    baseUrl: processEnv.APP_URL
  },
  getSeoFromSeoManager: {
    //从seomanager这获取seo数据
    url: "/service/seoManager/getSeoManager",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },

  /*-------------------------------------------- 内容组 ----------------------------------------------------*/
  saveContentGroup: {
    // 添加内容组
    url: "/cmscontent/appContentGroupService/insert",
    method: "POSTJSON",
    //authPermission: "12"
  },
  updateContentGroup: {
    // 编辑内容组
    url: "/cmscontent/appContentGroupService/update",
    method: "POSTJSON",
    //authPermission: "13"
  },
  deleteContentGroup: {
    // 删除内容组
    url: "/cmscontent/appContentGroupService/delete",
    method: "GET",
    //authPermission: "14"
  },
  selectContentGroup: {
    // 选择内容组
    url: "/cmscontent/appContentGroupService/select",
    method: "GET"
  },

  findContentGroups: {
    // 查找内容组
    url: "/cmscontent/appContentGroupService/findByPagination",
    method: "POSTJSON"
  },

  deleteByContentIdAndGroupId: {
    // 根据内容id移出内容组
    url: "/cmscontent/contentGroupingService/deleteByContentIdAndGroupId",
    method: "GET",
    //authPermission: "13"
  },
  delTaskByContentId:{
    // 根据内容id移出内容组
    url: "/examine/task/delTaskByContentId",
    method: "POSTJSON",
  },  
  /*-------------------------------------------- 回收站 ----------------------------------------------------*/
  restoreAll: {
    //全部还原
    url: "/cmscontent/contentManualService/restoreAll",
    method: "GET",
    //authPermission: "6"
  },
  emptyTrash: {
    //清空回收站
    url: "/cmscontent/appContentService/emptyTrash",
    method: "GET",
    //authPermission: "7"
  },
  delContent: {
    //删除回收站
    url: "/cmscontent/appContentService/deletes",
    method: "POSTJSON",
    //authPermission: "7"
  },
  /*-------------------------------------------- 模板设置 ----------------------------------------------------*/
  findPageList: {
    // 获取模板
    url: "/site/page/findPageList",
    method: "GET",
    baseUrl: processEnv.SASSSERVICE_ROOT,
    isGwforward:true//true走gwforward转发
  },

  /*-------------------------------------------- 视频管理 ----------------------------------------------------*/
  getKSConfig: {
    // 获取金山云配置
    url: "/sk/storage/getKSConfig",
    method: "GET"
  },
  getSignature: {
    // 获取金山云签名
    url: "/sk/storage/getSignature",
    method: "POSTJSON"
  },

  // 获取阿里云签名
  getAliyunConfig: {
    url: "/alivideo/aliVideoService/createVideo",
    method: "POSTJSON"
  },

  saveVideo: {
    // 保存视频信息
    url: "/video/videoService/save",
    method: "POSTJSON",
    //authPermission: "53"
  },
  updateVideoBasic: {
    // 更新视频基础信息
    url: "/video/videoService/update",
    method: "POSTJSON",
    //authPermission: "53"
  },
  updateVideoMeta: {
    // 更新视频源信息
    url: "/video/app/updateVideoMeta",
    method: "POSTJSON",
    //authPermission: "53"
  },
  updateVideoTransCode: {
    // 将视频源转码
    url: "/video/app/updateVideoTransCode",
    method: "POSTJSON",
    //authPermission: "53"
  },
  findVideoByPagination: {
    // 获取视频列表
    url: "/video/videoService/findByPagination",
    method: "POSTJSON"
  },
  deleteVideo: {
    // 删除视频
    url: "/video/app/batchDelete",
    method: "POSTJSON",
    //authPermission: "56"
  },
  getVideoCount: {
    // 获取分类视频总数
    url: "/video/videoService/getCount",
    method: "GET"
  },
  batchTransfer: {
    // 移动视频
    url: "/video/videoService/batchTransfer",
    method: "POSTJSON",
    //authPermission: "55"
  },
  findAllClassifyByVideo: {
    //获取APP_ID下所有视频分类findAllClassify及数量
    url: "/video/app/findAllClassify",
    method: "POSTJSON"
  },
  findByVideoId: {
    //根据视频ID获取视频
    url: "/video/videoService/findById",
    method: "GET"
  },

  // 新增视频服务提供方列表
  addVideoSupplier: {
    url: "/video/videoSupplierService/save",
    method: "POSTJSON"
  },

  // 获取使用状态获取服务商
  getSupplierByStatus: {
    url: "/video/videoSupplierService/findListByStatus",
    method: "GET"
  },

  // 获取视频服务提供方列表
  getVideoSupplierList: {
    url: "/video/videoSupplierService/findAll",
    method: "GET"
  },

  // 更新视频服务接口
  updateVideoSupplier: {
    url: "/video/videoSupplierService/update",
    method: "POSTJSON"
  },
  // 获取视频资源
  getVideoUsage: {
    url: "/video/videoService/getVideoUsage",
    method: "GET"
  },
  // 获取视频资源
  getUsedAndTotalCapacity: {
    url: "/video/videoService/getUsedAndTotalCapacity",
    method: "GET"
  },


  /*-------------------------------------------- 日志 ----------------------------------------------------*/

  log: {
    // 日志
    url: "/log/operLogService/findByPagination",
    method: "POSTJSON"
  },

  /*-------------------------------------------- 权限设置 ----------------------------------------------------*/

  // 获取已有权限
  selectPermission: {
    url: "/selectPermissions",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL
  },

  getRoles: {
    url: "/v2/UserRole/{memberCode}/getRolesByUserInfo",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL
  },

  // 获取所有权限项
  findPermissions: {
    url: "/findPermissions",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL
  },

  // 更新权限
  updatePermission: {
    url: "/v1/UpdatePermission",
    method: "POST",
    baseUrl: processEnv.PERMISSION_URL
  },

  /*-------------------------------------------- 系统设置 ----------------------------------------------------*/
  getIpList: {
    //ip黑名单
    url: "/blackList/blackListService/findByPagination",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT
  },
  getIpNum: {
    url: "/blackList/blackListService/findCount",
    method: "GET",
    baseUrl: processEnv.IP_ROOT
  },
  addIp: {
    url: "/blackList/blackListService/save",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT,
    //authPermission: "71"
  },
  updateIp: {
    url: "/blackList/blackListService/update",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT,
    //authPermission: "72"
  },
  deleteIp: {
    url: "/blackList/blackListService/deleteByIds",
    method: "POSTJSON",
    baseUrl: processEnv.IP_ROOT,
    //authPermission: "73"
  },
  getSensitiveWordList: {
    //敏感词列表
    url: "/illegalWord/illegalWordService/findByPagination",
    method: "POSTJSON",
    baseUrl: process.env.SENSITIVEWORD_URL
  },
  deleteSensitiveWord: {
    url: "/illegalWord/illegalWordService/deleteByIds",
    method: "POSTJSON",
    baseUrl: process.env.SENSITIVEWORD_URL,
    //authPermission: "70"
  },
  addSensitiveWord: {
    url: "/illegalWord/illegalWordService/save",
    method: "POSTJSON",
    baseUrl: process.env.SENSITIVEWORD_URL,
    //authPermission: "68"
  },
  updateSensitiveWord: {
    url: "/illegalWord/illegalWordService/update",
    method: "POSTJSON",
    baseUrl: process.env.SENSITIVEWORD_URL,
    //authPermission: "69"
  },
  upLoadSensitiveWord: {
    url: "/illegalWord/illegalWordService/importData",
    method: "POSTJSON",
    baseUrl: process.env.SENSITIVEWORD_URL,
    //authPermission: "68"
  },
  exportTemplate: {
    //下载敏感词模板
    url: processEnv.AUTHORITY
      ? processEnv.GATEWAY?processEnv.GATEWAY+"/local/export/illegalTemplate.do" 
      : "/export/illegalTemplate.do"
      : "/illegalWord/illegalWordService/exportTemplate",
    method: "GET",
    //authPermission: "68",
    baseUrl: processEnv.AUTHORITY
      ? processEnv.API_ROOT
      : processEnv.SENSITIVEWORD_URL,
    authority: 1
  },
  getRemindList: {
    //业务提醒列表
    url: "/remind/event/findEventByConditionWithPage",
    method: "POSTJSON"
  },
  findRemindedAppList: {
    //获取应用列表
    url: "/remind/event/findRemindedAppList",
    method: "GET"
  },
  // 获取业务提醒详情
  getRemind: {
    url: "/remind/event/findAllTemplateByEventId",
    method: "GET"
  },

  getRemindTemplate: {
    //初始化模板内容
    url: "/remind/event/findTemplateByEventIdOrFormId",
    method: "GET"
  },
  restoreTemplateDefault: {
    //恢复默认模板
    url: "/remind/event/findTemplateByTempId",
    method: "GET"
  },
  getEventParams: {
    //获取事件替换属性
    url: "/remind/event/findParamsByEventId",
    method: "GET"
  },
  saveRemind: {
    //保存业务提醒
    url: "/remind/event/updateTemplate",
    method: "POSTJSON",
    //authPermission: "76"
  },
  emailTestTemp: {
    //模板邮件测试
    url: "/remind/event/sendTestEmail",
    method: "POSTJSON"
  },
  emailTestSet: {
    //设置邮件测试
    url: "/config/messageSenderService/sendMailMessage",
    method: "POSTJSON"
  },
  messageboardCategory: {
    url: "/messageboard/messageboardCategory/find",
    method: "GET"
  },
  // 获取所有敏感词
  findAllIllegalWord: {
    url: "/illegalWord/illegalWordService/findListAll",
    method: "GET",
    baseUrl: process.env.SENSITIVEWORD_URL
  },
  getLoginUser: {
    url: processEnv.GATEWAY?processEnv.GATEWAY+"/local/getLoginUser.do" : "/getLoginUser.do",
    method: "GET",
    baseUrl: processEnv.MANAGER_URL,
    authority: 1 //不需要拦截
  },
  cleanAllStatic: {
    // 一键清除静态化
    url: processEnv.GATEWAY?processEnv.GATEWAY+"/local/static/cleanStaitcPageAll.do":"/static/cleanStaitcPageAll.do",
    method: "GET",
    // authPermission: "340"
    authority: 1 //不需要拦截
  },
  /********************高呈接口***********************/
  getSiteList: {
    url: "/site-api/getSites",
    method: "GET",
    baseUrl: processEnv.MCENTER_URL,
    authority: 1 //不需要拦截
  },
  getRoleList: {
    //获取角色列表
    url: "/v1/Role/getRoleByCondition",
    method: "GET",
    baseUrl: processEnv.PERMISSION_URL,
  },
  getUserList: {
    //获取用户列表
    url: "/user-api/getUserListByCustId",
    method: "GET",
    baseUrl: processEnv.MCENTER_URL,
    authority: 1 //不需要拦截
  },

  /*-------------------------------------------- 审核设置 ----------------------------------------------------*/
  findByConditionWithPage: {
    // 获取审核流列表
    url: "/examine/definition/findByConditionWithPage",
    method: "POSTJSON"
  },
  validateName: {
    // 校验审核流名称是否存在
    url: "/examine/definition/validateName",
    method: "GET"
  },
  saveDefinition: {
    // 新增审核流
    url: "/examine/definition/saveDefinition",
    method: "POSTJSON",
    //authPermission: "37"
  },
  validateStep: {
    // 校验是否可更新stepslist
    url: "/examine/definition/validateStep",
    method: "GET"
  },
  updateDefinition: {
    // 更新审核流
    url: "/examine/definition/updateDefinition",
    method: "POSTJSON",
    //authPermission: "38"
  },
  deleteDefinition: {
    // 删除审核流
    url: "/examine/definition/deleteDefinition",
    method: "POSTJSON",
    //authPermission: "39"
  },
  getDefinitionById: {
    // 根据ID获取审核流
    url: "/examine/definition/getDefinitionById",
    method: "GET"
  },
  updateColumnBase: {
    // 修改栏目审核设置
    url: "/cmscolumn/column/updateColumnBase",
    method: "POSTJSON",
    //authPermission: "101"
  },
  getDefinitionByRelationId: {
    // 保存审核流的关联
    url: "/examine/definition/getDefinitionByRelationId",
    method: "GET"
  },
  saveRelation: {
    // 保存审核流的关联
    url: "/examine/definition/saveRelation",
    method: "POSTJSON",
    //authPermission: "101"
  },
  updateRelation: {
    // 更新审核流的关联
    url: "/examine/definition/updateRelation",
    method: "POSTJSON",
    //authPermission: "38"
  },
  validateRelation: {
    // 校验是否可以修改关联
    url: "/examine/definition/validateRelation",
    method: "POSTJSON"
  },
  deleteRelation: {
    // 删除栏目与审核间的关联
    url: "/examine/definition/deleteRelation",
    method: "POSTJSON"
  },
  findTaskByConditionWithPage: {    // 获取审批任务列表
    url: "/examine/task/findTaskByConditionWithPage",
    method: "POSTJSON"
  },
  findAppTaskByConditionWithPage: { // 获取审批任务列表
    url: '/examine/apptask/findTaskByConditionWithPage',
    method: 'POSTJSON'
  },
  findAppTaskLogByCondition: { // 获取审批任务列表
    url: '/examine/apptask/findTaskLogByCondition',
    method: 'POSTJSON'
  },
  saveTask: {
    // 保存审批任务
    url: "/examine/apptask/saveTask",
    method: "POSTJSON",
    //authPermission: "columnId:27"
  },
  findTaskDetail: {
    // 根据ID获取审批任务
    url: "/examine/task/findTaskDetail",
    method: "GET"
  },
  validateExamine: {
    // 判断用户是否有当前的审批权限
    url: "/examine/task/validateExamine",
    method: "GET"
  },
  updateTask: {
    // 审批任务
    url: "/examine/apptask/updateTask",
    method: "POSTJSON"
  },
  updateTaskName: {
    // 更新审核任务名
    url: "/examine/task/updateTaskName",
    method: "POSTJSON",
    //authPermission: "38"
  },
  findTaskLogByCondition: {
    // 根据审批任务ID获取审批日志
    url: "/examine/task/findTaskLogByCondition",
    method: "POSTJSON"
  },
  findTaskLogByConditionWithPage: { // 根据审批任务ID获取审批日志
    url: '/examine/apptask/findTaskLogByConditionWithPage',
    method: 'POSTJSON'
  },

  /*-------------------------------------------- 万能表单 ----------------------------------------------------*/
  getCollectionFormList: {
    //获取所有收集到的表单
    url: "/formAttrValue/formAttrValueService/getAllFormNumber",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL
  },
  deleteMoreFormNumber: {
    //删除收集到的表单
    url: "/formAttrValue/formAttrValueService/deleteMoreFormNumber",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    //authPermission: "63"
  },
  updateFormNumber: {
    //更新收集到的表单
    url: "/formAttrValue/formAttrValueService/updateFormNumber",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    //authPermission: "62"
  },
  getAttrValue: {
    //根据ID获取收集到的表单
    url: "/formAttrValue/formAttrValueService/getAttrValue",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL
  },
  saveFormNumberRemarks: {
    //备注表单
    url: "/formAttrValue/formAttrValueService/saveFormNumberRemarks",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    //authPermission: "62"
  },
  getAllFormNoPage: {
    //获取所有表单设置没有分页
    url: "/universalfForm/universalfFormService/getAllForm",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL
  },
  getAllForm: {
    //获取所有表单设置
    url: "/universalfForm/universalfFormService/getAllFormByCondition",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL
  },
  getFormSettingById: {
    //根据ID获取表单
    url: "/universalfForm/universalfFormService/getForm",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL
  },
  getFormFiexd: {
    //获取表单固有字段
    url: "/universalfForm/universalfFormService/getFormFiexd",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL
  },
  saveForm: {
    //保存表单设置
    url: "/universalfForm/universalfFormService/saveForm",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    //authPermission: "64"
  },
  updateFormStatus: {
    //更改表单状态
    url: "/universalfForm/universalfFormService/updateForm",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    //authPermission: "65"
  },
  deleteFormSetting: {
    //更改表单状态
    url: "/universalfForm/universalfFormService/deleteForm",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    //authPermission: "66"
  },
  getPrivacy: {
    //获取隐私政策
    url: "/universalfForm/universalfFormService/getPrivacy",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL
  },
  updatePrivacy: {
    //更新隐私政策
    url: "/universalfForm/universalfFormService/updatePrivacy",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    //authPermission: "67"
  },
  exportFormValueAllList: {
    //导出所有表单
    url: "/exportFormData/exportFormDataService/exportFormValueAllList",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL,
    authority: 1 //不需要拦截
  },
  exportFormValueList: {
    //获取指定表单的导出路径
    url: "/exportFormData/exportFormDataService/exportFormValueList",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL
  },
  exportByFilePath: {
    //根据导出路径下载文件
    url: "/exportFormData/exportFormDataService/export",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL,
    authority: 1 //不需要拦截
  },
  universalfForm_getRecipientMail: {
    //获取转发设置详情
    url: "/universalfForm/universalfFormService/getRecipientMail",
    method: "GET",
    baseUrl: process.env.MULTIFORM_URL,
    authority: 1
  },
  universalfForm_updateRecipientMail: {
    //编辑转发设置
    url: "/universalfForm/universalfFormService/updateRecipientMail",
    method: "POSTJSON",
    baseUrl: process.env.MULTIFORM_URL,
    authority: 1
  },

  /*-------------------------------------------- 留言 ----------------------------------------------------*/

  // 全网后台接口
  // http://10.12.52.51:1982/api/messageboard/appMessageboardMessage/findMessageAndRelpyByPagination?tenantId=1600024221

  // 获取留言列表
  getMessageList: {
    url: "/messageboard/appMessageboardMessage/findMessageAndRelpyByPagination",
    method: "POSTJSON"
  },

  // 根据留言id显示隐藏留言
  updateMessageDisplayFlag: {
    url: "/messageboard/messageboardMessage/updateDisplayFlagByIds",
    method: "POSTJSON",
    //authPermission: "61"
  },

  // 根据留言id删除留言
  deleteMessage: {
    url: "/messageboard/messageboardMessage/deleteByIds",
    method: "POSTJSON",
    //authPermission: "59"
  },

  // 根据留言id获取回复
  getMessageReplyList: {
    url: "/messageboard/messageboardMessage/findReplyListByMessageId",
    method: "POSTJSON"
  },

  // 添加回复
  saveMessageReply: {
    url: "/messageboard/messageboardReply/saveReply",
    method: "POSTJSON",
    //authPermission: "58"
  },

  // 根据回复id显示隐藏回复
  updateMessageReplyDisplayFlag: {
    url: "/messageboard/messageboardReply/updateDisplayFlag",
    method: "POSTJSON",
    //authPermission: "61"
  },

  // 根据留言id和回复id删除回复
  updateMessageReplyDeleteFlag: {
    url: "/messageboard/messageboardReply/updateDeleteFlag",
    method: "POSTJSON",
    //authPermission: "59"
  },

  // 获取留言表单列表
  getMessageFormList: {
    url: "/messageboard/messageboardCategory/findByIndexPagination",
    method: "POSTJSON"
  },

  // 获取所有留言表单列表
  getAllMessageFormList: {
    url: "/messageboard/messageboardCategory/findByPagination",
    method: "POSTJSON"
  },

  // 留言表单启用/停用
  updatetMessageFormUseFlag: {
    url: "/messageboard/messageboardCategory/updateUseFlag",
    method: "POSTJSON",
    //authPermission: "81"
  },

  // 获取表单详情
  getMessageFormDetail: {
    url: "/messageboard/messageboardCategory/get",
    method: "GET"
  },

  // 保存表单
  saveMessageForm: {
    url: "/messageboard/messageboardForm/saveForm",
    method: "POSTJSON",
    //authPermission: "80"
  },

  // 更新表单
  updateMessageForm: {
    url: "/messageboard/messageboardForm/updateForm",
    method: "POSTJSON",
    //authPermission: "81"
  },

  // 获取表单固定项
  getTemplateFormWithItem: {
    url: "/messageboard/messageboardForm/getTemplateFormWithItem",
    method: "GET"
  },

  // 获取表单项
  getMessageFormItemList: {
    url: "/messageboard/messageboardForm/getFormWithItem",
    method: "GET"
  },

  /*-------------------------------------------- 地图 ----------------------------------------------------*/
  //获取网点列表
  getMapList: {
    url: "/map/position/findByPagination",
    method: "POSTJSON"
  },
  //根据Id获取网点
  getMapById: {
    url: "/map/position/getDetail",
    method: "GET"
  },
  //添加网点
  addMap: {
    url: "/map/position/add",
    method: "POSTJSON",
    //authPermission: "40"
  },
  //编辑网点
  editMap: {
    url: "/map/position/update",
    method: "POSTJSON",
    //authPermission: "41"
  },
  //删除网点
  deleteMapById: {
    url: "/map/position/delete",
    method: "GET",
    //authPermission: "42"
  },
  //获取所有品牌
  getCardList: {
    url: "/map/card/findCardAllPosition",
    method: "GET"
  },
  //根据ID获取品牌
  getCardById: {
    url: "/map/card/getById",
    method: "GET"
  },
  //更新品牌
  editCard: {
    url: "/map/card/update",
    method: "POSTJSON",
    //authPermission: "99"
  },
  //添加品牌
  addCard: {
    url: "/map/card/add",
    method: "POSTJSON",
    //authPermission: "100"
  },
  //删除品牌
  deleteCardById: {
    url: "/map/card/deleteById",
    method: "GET",
    //authPermission: "42"
  },

  //获取所有分类
  getCategoryList: {
    url: "/map/category/findPositionCount",
    method: "GET"
  },

  //获取详细地址
  getBaiDuMap: {
    url: "/map/position/getBaiDuMap",
    method: "GET"
  },

  //根据ID获取分类
  getCategoryById: {
    url: "/map/category/getCategoryById",
    method: "GET"
  },
  //更新分类
  editCategory: {
    url: "/map/category/update",
    method: "POSTJSON",
    //authPermission: "96"
  },
  //添加分类
  addCategory: {
    url: "/map/category/add",
    method: "POSTJSON",
    //authPermission: "95"
  },
  //删除分类
  deleteCategoryById: {
    url: "/map/category/delete",
    method: "GET",
    //authPermission: "97"
  },
  //更新地图拖拽排序
  updateMapSort:{
    url:"/map/position/updateSort",
    method: "POSTJSON",
  },

  /*-------------------------------------------- 招聘 ----------------------------------------------------*/
  //查询所有职能部门
  getDepartmentList: {
    url: "/job/department/findAll",
    method: "GET",
    baseUrl: process.env.JOB_URL
  },
  //保存职能部门
  addDepartment: {
    url: "/job/department/saveJobDepartment",
    method: "POSTJSON",
    baseUrl: process.env.JOB_URL,
    //authPermission: "105"
  },
  //修改职能部门
  updateDepartment: {
    url: "/job/department/updateJobDepartment",
    method: "POSTJSON",
    baseUrl: process.env.JOB_URL,
    //authPermission: "106"
  },
  //根据批量删除id职能部门
  deleteDepartment: {
    url: "/job/department/deleteJobDepartmentByIds",
    method: "POSTJSON",
    baseUrl: process.env.JOB_URL,
    //authPermission: "107"
  },
  //分页查询职务列表
  getJobList: {
    url: "/job/posting/findWithPage",
    method: "POSTJSON",
    baseUrl: process.env.JOB_URL
  },
  //根据职务id获取特定的职务
  getJobById: {
    url: "/job/posting/getJobById",
    method: "GET",
    baseUrl: process.env.GCJOB_URL
  },
  //保存职务
  addJob: {
    url: "/job/posting/saveJob",
    method: "POSTJSON",
    baseUrl: process.env.GCJOB_URL,
    //authPermission: "102"
  },
  //修改职务
  updateJob: {
    url: "/job/posting/updateJob",
    method: "POSTJSON",
    baseUrl: process.env.GCJOB_URL,
    //authPermission: "103"
  },
  //根据批量职务Id删除职务
  deleteJob: {
    url: "/job/posting/deleteJobByIds",
    method: "POSTJSON",
    baseUrl: process.env.GCJOB_URL,
    //authPermission: "104"
  },
  //修改显示隐藏状态
  updateState: {
    url: "/job/posting/updateState",
    method: "POSTJSON",
    baseUrl: process.env.JOB_URL,
    //authPermission: "103"
  },
  //修改职位部门
  updateJobDepartment: {
    url: "/job/posting/updateDepartment",
    method: "POSTJSON",
    baseUrl: process.env.JOB_URL,
    //authPermission: "103"
  },
  //修改职位发布时间
  updatePublicTime: {
    url: "/job/posting/updatePublicTime",
    method: "POSTJSON",
    baseUrl: process.env.JOB_URL,
    //authPermission: "103"
  },

  //获取岗位列表（新需求）
  getJobPageList: {
    url: "/job/posting/getJobPageList",
    method: "POSTJSON",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //获取申请人列表（新需求）
  getJobApplyDataList: {
    url: "/job/posting/getJobApplyDataList",
    method: "POSTJSON",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //导出全部申请人信息
  exportJobApplyData: {
    url: "/exportApplyData/exportApplyDataService/exportJobApplyData",
    method: "GET",
    baseUrl: process.env.GCJOBNEW_URL,
    // authPermission: "103"
    authority: 1 //不需要拦截
  },

  //生成选择数据的Excel和附件的压缩包
  generateApplyDataFile: {
    url: "/exportApplyData/exportApplyDataService/generateApplyDataFile",
    method: "POSTJSON",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //根据url下载文件
  exportApplyByFilePath: {
    url: "/exportApplyData/exportApplyDataService/exportByFilePath",
    method: "GET",
    baseUrl: process.env.GCJOBNEW_URL,
    // authPermission: "103"
    authority: 1 //不需要拦截
  },

  //根据id删除申请（新需求）
  deleteJobApplyData: {
    url: "/job/posting/deleteJobApplyData",
    method: "POSTJSON",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //获取申请人详情（新需求）
  getJobApplyDataById: {
    url: "/job/posting/getJobApplyDataById",
    method: "GET",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //根据职位id获取接收者邮箱
  getRecipientMail: {
    url: "/job/posting/getRecipientMail",
    method: "GET",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //添加或修改接收者邮箱
  updateRecipientMail: {
    url: "/job/posting/updateRecipientMail",
    method: "POSTJSON",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //查询招聘表单字段
  getJobForm: {
    url: "/job/posting/getJobForm",
    method: "GET",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  //修改表单
  updateJobForm: {
    url: "/job/posting/updateJobForm",
    method: "POSTJSON",
    baseUrl: process.env.GCJOBNEW_URL
    // authPermission: "103"
  },

  /*********获取会员中心页面***************/
  delColumnValidate: {
    url: "/cmscontent/appContentForwardService/isForward",
    method: "POSTJSON",
  },

  /*********中金净值相关接口***************/
  importNetWorthFile: {
    //导入净值文件
    url: "/netWorth/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importETFNetWorthFile: {
    //导入ETF净值文件
    url: "/netWorthProduct/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importStockFile: {
    //导入组合持仓文件
    url: "/combinationPosition/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importTrackFile: {
    //导入追踪差异文件
    url: "/etf/track/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  getNetWorthList: {
    //获取净值列表
    url: "/netWorth/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getETFnetWorthList: {
    //获取ETF净值列表
    url: "/netWorthProduct/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getStockList: {
    //获取组合持仓列表
    url: "/combinationPosition/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getTrackList: {
    //获取追踪差异列表
    url: "/etf/track/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getNetWorthById: {
    //根据id获取净值
    url: "/netWorth/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getETFNetWorthById: {
    //根据id获取ETF净值
    url: "/netWorthProduct/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getStockById: {
    //根据id获取组合持仓
    url: "/combinationPosition/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getTrackById: {
    //根据id获取追踪差异
    url: "/etf/track/selectById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateNetWorth: {
    //更新净值
    url: "/netWorth/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateETFNetWorth: {
    //更新ETF净值
    url: "/netWorthProduct/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateStock: {
    //更新组合持仓
    url: "/combinationPosition/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateTrack: {
    //更新组合持仓
    url: "/etf/track/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteNetWorthById: {
    //删除净值
    url: "/netWorth/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteETFNetWorthById: {
    //删除ETF净值
    url: "/netWorthProduct/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteStockById: {
    //删除组合持仓
    url: "/combinationPosition/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteTrackById: {
    //删除追踪差异
    url: "/etf/track/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getBonusList: {
    //分红列表
    url: "/bonus/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getProductList: {
    //产品列表
    url: "/product/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addBonus: {
    //添加分红
    url: "/bonus/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateBonus: {
    //更新分红
    url: "/bonus/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getBonusById: {
    //根据id查询分红详情
    url: "/bonus/toEdit",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteBonus: {
    //删除分红
    url: "/bonus/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getHolidayList: {
    //获取节假日列表
    url: "/holiday/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addHoliday: {
    //添加节假日
    url: "/holiday/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteHoliday: {
    //删除节假日
    url: "/holiday/deleteById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getHolidayById: {
    //根据id查找节假日
    url: "/holiday/selectDetailsById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateHoliday: {
    //根据id查找节假日
    url: "/holiday/updateById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  downloadHolidayTemplate: {
    //下载节假日模版
    url: "/holiday/exprotTemplate",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  importHolidayFile: {
    //导入节假日文件
    url: "/holiday/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },

  selectProductNwsListPage: {
    //查询产品净值的综合数据(分页)
    url: "/netWorth/selectProductNwsListPage",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  /*********中金客户相关接口***************/
  getCustomerList: {
    //获取客户列表
    url: "/customer/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getAllCustomerList: {
    //获取客户列表(不带分页)
    url: "/customer/queryAll",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addCustomer: {
    //新增客户
    url: "/customer/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getCustomerById: {
    //新增客户
    url: "/customer/toEdit",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateCustomer: {
    //更新客户
    url: "/customer/update",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteCustomer: {
    //删除客户
    url: "/customer/delete",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getCustomerGroupList: {
    //获取客户分组列表
    url: "/grouping/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getCustomerAllGroupList: {
    //获取客户分组列表(不分页)
    url: "/grouping/queryAll",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  addCustomerGroup: {
    //添加客户分组
    url: "/grouping/synch",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  getCustomerGroupById: {
    //根据id获取客户分组
    url: "/grouping/toEdit",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  updateCustomerGroup: {
    //编辑客户分组
    url: "/grouping/update",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteCustomerGroup: {
    //删除客户分组
    url: "/grouping/delete",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },

  getEmailList: {
    //获取发送邮件列表
    url: "/mail/list",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  deleteEmail: {
    //删除邮件
    url: "/mail/delete",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  sendEmailToCustomer: {
    //发送邮件
    url: "/mail/send",
    method: "SENDMAIL",
    baseUrl: processEnv.CNFOL_URL,
    authority: 1 //不需要拦截
  },
  getEmailDetail: {
    //获取邮件详情
    url: "/mail/findMailById",
    method: "POSTJSON",
    baseUrl: processEnv.CNFOL_URL
    // authority: 1 //不需要拦截
  },
  
  /*********人员管理相关接口***************/
  importEmployee: {
    //导入员工信息
    url: "/peopleDigital/employee/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  addEmployee: {
    //添加员工信息
    url: "/peopleDigital/employee/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  deleteEmployee: {
    //删除员工信息
    url: "/peopleDigital/employee/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  modifyEmployee: {
    //修改员工信息
    url: "/peopleDigital/employee/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getEmployeeList: {
    //获取员工信息列表
    url: "/peopleDigital/employee/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getEmployeeById: {
    //获取员工信息列表
    url: "/peopleDigital/employee/getEmployeeById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  setEmployeeRegionByIds: {
    //根据ID变更区域信息
    url: "/peopleDigital/employee/setRegionByIds",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  setEmployeeColumnStatus: {
    //设置员工字段显示、隐藏
    url: "/peopleDigital/employee/setColumnStatus",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  importBranch: {
    //导入分公司信息
    url: "/peopleDigital/branch/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  addBranch: {
    //添加分公司信息
    url: "/peopleDigital/branch/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  deleteBranch: {
    //删除分公司信息
    url: "/peopleDigital/branch/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  modifyBranch: {
    //修改分公司信息
    url: "/peopleDigital/branch/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getBranchList: {
    //获取分公司信息列表
    url: "/peopleDigital/branch/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getBranchById: {
    //根据ID获取分公司信息列表
    url: "/peopleDigital/branch/getBranchById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  setBranchRegionByIds: {
    //根据ID变更分公司信息
    url: "/peopleDigital/branch/setRegionByIds",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  setBranchColumnStatus: {
    //设置分公司字段显示、隐藏
    url: "/peopleDigital/branch/setColumnStatus",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  importAgent: {
    //导入代理商信息
    url: "/peopleDigital/agent/import",
    method: "UPLOADFILE",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  addAgent: {
    //添加代理商信息
    url: "/peopleDigital/agent/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  deleteAgent: {
    //删除代理商信息
    url: "/peopleDigital/agent/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  modifyAgent: {
    //修改代理商信息
    url: "/peopleDigital/agent/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getAgentList: {
    //获取代理商信息列表
    url: "/peopleDigital/agent/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getAgentById: {
    //根据ID获取代理商信息列表
    url: "/peopleDigital/agent/getAgentById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  setAgentRegionByIds: {
    //根据ID变更代理商信息
    url: "/peopleDigital/agent/setRegionByIds",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  setAgentColumnStatus: {
    //设置代理商字段显示、隐藏
    url: "/peopleDigital/agent/setColumnStatus",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  addRegion: {
    //添加区域信息
    url: "/peopleDigital/region/add",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  deleteRegion: {
    //删除区域信息
    url: "/peopleDigital/region/delete",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  modifyRegion: {
    //修改区域信息
    url: "/peopleDigital/region/modify",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getRegionList: {
    //获取区域信息列表
    url: "/peopleDigital/region/list",
    method: "GET",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },
  getRegionById: {
    //根据ID获取区域信息列表
    url: "/peopleDigital/region/getRegionById",
    method: "POSTJSON",
    baseUrl: processEnv.GCDAILY_URL,
    // authority: 1 //不需要拦截
  },

  /*********尚赫相关接口***************/
  webSiteOverview: {
    //网站概况
    url: "/statistics/StatisticsService/webSiteOverview",
    method: "POSTJSON",
    baseUrl: processEnv.SUNHOPE_URL
    // authority: 1 //不需要拦截
  },
  downloadOverview: {
    //下载记录
    url: "/statistics/StatisticsService/dowViews",
    method: "POSTJSON",
    baseUrl: processEnv.SUNHOPE_URL
    // authority: 1 //不需要拦截
  },
  viewStatisticsList: {
    //统计列表
    url: "/statistics/StatisticsService/viewList",
    method: "POSTJSON",
    baseUrl: processEnv.SUNHOPE_URL
    // authority: 1 //不需要拦截
  },
  exportAccessList: {
    //导出excel
    url: "/statistics/StatisticsService/exportAccessList",
    method: "GET",
    baseUrl: processEnv.SUNHOPE_URL,
    authority: 1, //不需要拦截
    //authPermission: "306"
  },

  /***********************************上海共创*************************************/
  //获取问卷列表
  getQuestionnaireList: {
    url: "/questionnaire/list",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //添加问卷
  addQuestionnaire: {
    url: "/questionnaire/synch",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //获取问卷详情
  getQuestionnaireDetail: {
    url: "/questionnaire/echoEcho",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新问卷
  updateQuestionnaire: {
    url: "/questionnaire/updateById",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新问卷状态（有效/无效）
  updateQuestionnaireStatus: {
    url: "/questionnaire/updateStatusById",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //删除问卷
  deleteQuestionnaire: {
    url: "/questionnaire/deleteByIds",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //获取问卷转发设置详情
  getQuestionnaireEmailCfg: {
    url: "/questionnaire/findEmailConfig",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新问卷转发设置
  updateQuestionnaireEmailCfg: {
    url: "/questionnaire/updateEmailConfigById",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },

  //获取答卷列表
  getAnswerList: {
    url: "/useriofo/list",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //获取答卷详情
  getAnswerDetail: {
    url: "/useriofo/findEditEcho",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //删除答卷
  deleteAnswer: {
    url: "/useriofo/deleteByIds",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //更新答卷状态（有效/无效）
  updateAnswerStatus: {
    url: "/useriofo/updateStatusByUuid",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //添加答卷处理日志
  addAnswerHandleLog: {
    url: "/useriofo/insertPaperProcessingByUuid",
    baseUrl: processEnv.ANSWER_MNG,
    method: "POSTJSON",
    authority: 1
  },
  //导出所有答卷
  exportAllAnswer: {
    url: "/useriofo/exprotTemplate",
    baseUrl: processEnv.ANSWER_MNG,
    method: "GET",
    authority: 1
  },
  //导出选中的答卷
  exportSelectedAnswer: {
    url: "/useriofo/exprotTemplateByUuid",
    baseUrl: processEnv.ANSWER_MNG,
    method: "GET",
    authority: 1
  }
};
/* Object.defineProperty(store.state.admin,'permissionInfo',{
  get:function(){
      return permissionInfo;
  },
  set:function(newValue){
    permissionInfo=newValue;

    console.log('set1 :',newValue);
    //需要触发的渲染函数可以写在这...
    store.state.admin.permissionInfo = newValue
    config.saveColumn.authPermission = newValue.column_add
    console.log('set 21:',config.saveColumn);

  }
}) */
setTimeout(function(){
  //栏目
  config.saveColumn.authPermission = store.state.admin.permissionInfo.column_add
  config.copyColumn.authPermission = store.state.admin.permissionInfo.column_add  
  config.deleteColumnByColumnIds.authPermission = store.state.admin.permissionInfo.column_delete
  config.validColumnByColumnIds.authPermission = store.state.admin.permissionInfo.column_delete
  config.delColumnValidate.authPermission = store.state.admin.permissionInfo.column_delete
  config.updateColumn.authPermission = store.state.admin.permissionInfo.column_update
  config.batchUpdateDisplay.authPermission = store.state.admin.permissionInfo.column_update
  config.ResetColumnGroupPK.authPermission = store.state.admin.permissionInfo.column_update  
  config.dragAndDropSort.authPermission = store.state.admin.permissionInfo.column_sort
  config.batchMoveColumn.authPermission = store.state.admin.permissionInfo.column_transfer
  config.saveGroup.authPermission = store.state.admin.permissionInfo.colum_group_add
  config.updateGroup.authPermission = store.state.admin.permissionInfo.colum_group_update
  config.saveColumnGroupPK.authPermission = store.state.admin.permissionInfo.colum_group_update  
  config.deleteGroup.authPermission = store.state.admin.permissionInfo.colum_group_delete
  config.saveField.authPermission = store.state.admin.permissionInfo.field_add
  config.saveFieldByTempId.authPermission = store.state.admin.permissionInfo.field_add
  config.updateField.authPermission = store.state.admin.permissionInfo.field_update
  config.updateFieldBase.authPermission = store.state.admin.permissionInfo.field_update
  config.dragAndDropSortField.authPermission = store.state.admin.permissionInfo.field_sort
  config.saveOrUpdateValidate.authPermission = store.state.admin.permissionInfo.field_update
  config.deleteField.authPermission = store.state.admin.permissionInfo.field_delete
  config.saveFieldGroup.authPermission = store.state.admin.permissionInfo.field_group_add
  config.updateFieldGroup.authPermission = store.state.admin.permissionInfo.field_group_update
  config.deleteFieldGroup.authPermission = store.state.admin.permissionInfo.field_group_delete
  config.rebackContent.authPermission = store.state.admin.permissionInfo.content_retrieve_reback
  config.deleteImageInfo.authPermission = store.state.admin.permissionInfo.image_delete
  config.updateImage.authPermission = store.state.admin.permissionInfo.image_update
  config.updateImageInfo.authPermission = store.state.admin.permissionInfo.image_update
  config.uploadImage.authPermission = store.state.admin.permissionInfo.image_add
  config.setWaterMark.authPermission = store.state.admin.permissionInfo.image_setting
  config.cancelWatermark.authPermission = store.state.admin.permissionInfo.image_setting
  config.saveOrUpdateWaterMark.authPermission = store.state.admin.permissionInfo.image_setting
  config.updateAppCode.authPermission = store.state.admin.permissionInfo.image_transfer
  config.saveClassify.authPermission = store.state.admin.permissionInfo.image_addtype
  config.updateClassify.authPermission = store.state.admin.permissionInfo.image_updatetype
  config.deleteClassifyByIds.authPermission = store.state.admin.permissionInfo.image_deletetype
  config.uploadFile.authPermission = store.state.admin.permissionInfo.file_add
  config.saveFile.authPermission = store.state.admin.permissionInfo.file_add  
  config.updateFile.authPermission = store.state.admin.permissionInfo.file_update
  config.modifyFileName.authPermission = store.state.admin.permissionInfo.file_update  
  config.deleteFileByIds.authPermission = store.state.admin.permissionInfo.file_delete
  config.transferFile.authPermission = store.state.admin.permissionInfo.file_transfer
  config.addBanner.authPermission = store.state.admin.permissionInfo.banner_add
  //config.batchAddAdvertContentForBanner.authPermission = store.state.admin.permissionInfo.banner_add
  config.updateBanner.authPermission = store.state.admin.permissionInfo.banner_update
  config.updateAdvertContentForBanner.authPermission = store.state.admin.permissionInfo.banner_update
  config.deleteAdvertContent.authPermission = store.state.admin.permissionInfo.banner_update
  config.deletePositionBanner.authPermission = store.state.admin.permissionInfo.banner_delete
  config.setBaseConfig.authPermission = store.state.admin.permissionInfo.basic_setting
  config.setSiteMail.authPermission = store.state.admin.permissionInfo.email_setting
  config.setSeoCode.authPermission = store.state.admin.permissionInfo.thirdparty_setting
  config.saveSeoSpread.authPermission = store.state.admin.permissionInfo.seo_betterrule
  config.updateSeoSpread.authPermission = store.state.admin.permissionInfo.seo_betterrule
  config.saveSeoOther.authPermission = store.state.admin.permissionInfo.seo_betterrule
  config.updateSeoOther.authPermission = store.state.admin.permissionInfo.seo_betterrule
  config.deleteSeoOther.authPermission = store.state.admin.permissionInfo.seo_betterrule
  config.saveRule.authPermission = store.state.admin.permissionInfo.seo_urlrule
  config.saveContentGroup.authPermission = store.state.admin.permissionInfo.content_group_add
  config.updateContentGroup.authPermission = store.state.admin.permissionInfo.content_group_update

  config.deleteContentGroup.authPermission = store.state.admin.permissionInfo.content_group_delete
  config.deleteByContentIdAndGroupId.authPermission = store.state.admin.permissionInfo.content_group_update
  config.restoreAll.authPermission = store.state.admin.permissionInfo.content_retrieve_reback
  config.emptyTrash.authPermission = store.state.admin.permissionInfo.content_retrieve_clear
  config.delContent.authPermission = store.state.admin.permissionInfo.content_retrieve_clear

  config.saveVideo.authPermission = store.state.admin.permissionInfo.video_add
  config.updateVideoBasic.authPermission = store.state.admin.permissionInfo.video_add
  config.updateVideoMeta.authPermission = store.state.admin.permissionInfo.video_add
  config.updateVideoTransCode.authPermission = store.state.admin.permissionInfo.video_add
  config.deleteVideo.authPermission = store.state.admin.permissionInfo.video_delete
  config.batchTransfer.authPermission = store.state.admin.permissionInfo.video_transfer
  config.addIp.authPermission = store.state.admin.permissionInfo.ipBlockList_add
  config.updateIp.authPermission = store.state.admin.permissionInfo.ipBlockList_update
  config.deleteIp.authPermission = store.state.admin.permissionInfo.ipBlockList_delete
  config.deleteSensitiveWord.authPermission = store.state.admin.permissionInfo.sensitiveWord_delete
  config.addSensitiveWord.authPermission = store.state.admin.permissionInfo.sensitiveWord_add
  config.upLoadSensitiveWord.authPermission = store.state.admin.permissionInfo.sensitiveWord_add
  config.exportTemplate.authPermission = store.state.admin.permissionInfo.sensitiveWord_add
  config.updateSensitiveWord.authPermission = store.state.admin.permissionInfo.sensitiveWord_update
  config.saveRemind.authPermission = store.state.admin.permissionInfo.businessReminding_set
  config.saveDefinition.authPermission = store.state.admin.permissionInfo.check_add
  config.updateDefinition.authPermission = store.state.admin.permissionInfo.check_update
  config.updateRelation.authPermission = store.state.admin.permissionInfo.check_open
  //config.updateTaskName.authPermission = store.state.admin.permissionInfo.check_update  
  config.deleteDefinition.authPermission = store.state.admin.permissionInfo.check_delete
  config.updateColumnBase.authPermission = store.state.admin.permissionInfo.check_open
  config.saveRelation.authPermission = store.state.admin.permissionInfo.check_open

  config.deleteMoreFormNumber.authPermission = store.state.admin.permissionInfo.omnipotentForm_delete
  config.updateFormNumber.authPermission = store.state.admin.permissionInfo.omnipotentForm_deal
  config.saveFormNumberRemarks.authPermission = store.state.admin.permissionInfo.omnipotentForm_deal
  config.saveForm.authPermission = store.state.admin.permissionInfo.omnipotentForm_set_add
  config.updateFormStatus.authPermission = store.state.admin.permissionInfo.omnipotentForm_set_update
  config.deleteFormSetting.authPermission = store.state.admin.permissionInfo.omnipotentForm_set_delete
  config.updatePrivacy.authPermission = store.state.admin.permissionInfo.omnipotentForm_policy_update
  config.updateMessageDisplayFlag.authPermission = store.state.admin.permissionInfo.message_update
  config.updateMessageReplyDisplayFlag.authPermission = store.state.admin.permissionInfo.message_update
  config.deleteMessage.authPermission = store.state.admin.permissionInfo.message_delete
  config.updateMessageReplyDeleteFlag.authPermission = store.state.admin.permissionInfo.message_delete
  config.saveMessageReply.authPermission = store.state.admin.permissionInfo.message_reply
  config.updatetMessageFormUseFlag.authPermission = store.state.admin.permissionInfo.message_set_update
  config.updateMessageForm.authPermission = store.state.admin.permissionInfo.message_set_update
  config.saveMessageForm.authPermission = store.state.admin.permissionInfo.message_set_add
  config.addMap.authPermission = store.state.admin.permissionInfo.map_add
  config.editMap.authPermission = store.state.admin.permissionInfo.map_update
  config.deleteMapById.authPermission = store.state.admin.permissionInfo.map_delete
  config.editCard.authPermission = store.state.admin.permissionInfo.map_updateBrand
  config.addCard.authPermission = store.state.admin.permissionInfo.map_addBrand //
  config.deleteCardById.authPermission = store.state.admin.permissionInfo.map_delBrand
  config.editCategory.authPermission = store.state.admin.permissionInfo.map_updatetype
  config.addCategory.authPermission = store.state.admin.permissionInfo.map_addtype
  config.deleteCategoryById.authPermission = store.state.admin.permissionInfo.map_deltype
  config.addDepartment.authPermission = store.state.admin.permissionInfo.department_add
  config.updateDepartment.authPermission = store.state.admin.permissionInfo.department_update
  config.deleteDepartment.authPermission = store.state.admin.permissionInfo.department_del
  config.addJob.authPermission = store.state.admin.permissionInfo.job_posted
  config.updateJob.authPermission = store.state.admin.permissionInfo.job_update
  config.updateState.authPermission = store.state.admin.permissionInfo.job_update
  config.updateJobDepartment.authPermission = store.state.admin.permissionInfo.department_update
  config.updatePublicTime.authPermission = store.state.admin.permissionInfo.department_update
  config.deleteJob.authPermission = store.state.admin.permissionInfo.job_del
  config.exportAccessList.authPermission = store.state.admin.permissionInfo.download_statistics
  config.updateTenantConfig.authPermission = store.state.admin.permissionInfo.advanced_response
  config.addTenantConfig.authPermission = store.state.admin.permissionInfo.advanced_response
  config.cleanAllStatic.authPermission = store.state.admin.permissionInfo.page_statization

  config.insertContent.authPermission = `columnId:${store.state.admin.permissionInfo.content_add}`
  config.importContentTemplate.authPermission = `columnId:${store.state.admin.permissionInfo.content_add}`
  config.copyInsert.authPermission = `columnId:${store.state.admin.permissionInfo.content_add}`  
  config.saveTask.authPermission = `columnId:${store.state.admin.permissionInfo.content_add}`  
  config.updateContent.authPermission = `columnId:${store.state.admin.permissionInfo.content_update}`
  config.updateShow.authPermission = `columnId:${store.state.admin.permissionInfo.content_update}`
  config.top.authPermission = `columnId:${store.state.admin.permissionInfo.content_update}`
  config.recommend.authPermission = `columnId:${store.state.admin.permissionInfo.content_update}`
  config.ResetContentGroupPK.authPermission = `columnId:${store.state.admin.permissionInfo.content_update}`
  config.hot.authPermission = `columnId:${store.state.admin.permissionInfo.content_update}`
  config.sort.authPermission = `columnId:${store.state.admin.permissionInfo.content_sort}`
  config.updateDel.authPermission = `columnId:${store.state.admin.permissionInfo.content_delete}`
  config.contentTransfer.authPermission = `columnId:${store.state.admin.permissionInfo.content_transfer}`
  config.manualForward.authPermission = `columnId:${store.state.admin.permissionInfo.content_transfer}`
  
},3000)

const constans = {
  // 常量
  RIGHT_CODE: ["101", "102", 200, "200"], // 正常
  REQUIRE_LOGIN: "999", // 用户未登录
  JURIS_CODE: "200", // 有权限
  NO_JURIS: "403" //没有权限
};
const errorCode = {};
const errorCodeByType = {};
errorCode[constans["RIGHT_CODE"]] = {};
errorCode[constans["REQUIRE_LOGIN"]] = {
  message: "用户未登录"
};
errorCode[constans["DEFAULT_CODE"]] = {
  message: "网络繁忙，请重试"
};
errorCode[constans["NO_JURIS"]] = {
  message: "没有权限，请联系管理员"
};

export { config, errorCode, errorCodeByType, constans };



// WEBPACK FOOTER //
// ./src/api/config.js